// Definition of the Label service API following AIP standards.

// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/workspace/v1/label_api.proto (package ai.h2o.workspace.v1, syntax proto3)
/* eslint-disable */

import type { Label } from "./label_pb";
import { RPC } from "../../../../runtime";

/**
 * @generated from message ai.h2o.workspace.v1.GetLabelRequest
 */
export type GetLabelRequest = {
/**
 * Required. Format: "labels/{label}"
 *
 * @generated from field: string name = 1;
 */
name?: string;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.GetLabelResponse
 */
export type GetLabelResponse = {
/**
 * @generated from field: ai.h2o.workspace.v1.Label label = 1;
 */
label?: Label;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.CreateLabelRequest
 */
export type CreateLabelRequest = {
/**
 * The label to create.
 *
 * @generated from field: ai.h2o.workspace.v1.Label label = 1;
 */
label?: Label;
/**
 * Required.
 * The label ID to use for this label.
 * Must match ^[a-z]([a-z0-9-]{0,61}[a-z0-9])?$ regular expression.
 *
 * @generated from field: string label_id = 2;
 */
labelId?: string;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.CreateLabelResponse
 */
export type CreateLabelResponse = {
/**
 * @generated from field: ai.h2o.workspace.v1.Label label = 1;
 */
label?: Label;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.UpdateLabelRequest
 */
export type UpdateLabelRequest = {
/**
 * @generated from field: ai.h2o.workspace.v1.Label label = 1;
 */
label?: Label;
/**
 * Only the fields specified in the update_mask are updated.
 *
 * Updatable fields are:
 *  - display_name
 *  - description
 *  - annotations and annotations.key
 *
 * @generated from field: google.protobuf.FieldMask update_mask = 2;
 */
updateMask?: string;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.UpdateLabelResponse
 */
export type UpdateLabelResponse = {
/**
 * @generated from field: ai.h2o.workspace.v1.Label label = 1;
 */
label?: Label;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.DeleteLabelRequest
 */
export type DeleteLabelRequest = {
/**
 * @generated from field: string name = 1;
 */
name?: string;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.DeleteLabelResponse
 */
export type DeleteLabelResponse = {
}
;
/**
 * @generated from message ai.h2o.workspace.v1.ListLabelsRequest
 */
export type ListLabelsRequest = {
/**
 * The maximum number of tags to return.
 *
 * @generated from field: int32 page_size = 1;
 */
pageSize?: number;
/**
 * A pagination token returned from a previous call.
 *
 * @generated from field: string page_token = 2;
 */
pageToken?: string;
/**
 * When used, server will only return labels that match the filter.
 * Attempts to generally implement AIP-160 (https://aip.dev/160)
 * specification.
 * See https://github.com/h2oai/authz-server/blob/main/docs/adopting.md#filtering for specific supported
 * features.
 *
 * Supported fields:
 *   * display_name
 *   * description
 *
 * Fields that are used for literal string matching:
 *  * display_name
 *  * description
 *  * identifier part of the name
 *
 * @generated from field: string filter = 3;
 */
filter?: string;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.ListLabelsResponse
 */
export type ListLabelsResponse = {
/**
 * @generated from field: repeated ai.h2o.workspace.v1.Label labels = 1;
 */
labels?: Label[];
/**
 * A token to retrieve the next page of results.
 *
 * @generated from field: string next_page_token = 2;
 */
nextPageToken?: string;
}
;
/**
 * Returns details of the label specified by the name.
 * All operations automatically scoped to authenticated user.
 * Users can only access their own labels.
 *
 * @generated from rpc ai.h2o.workspace.v1.LabelService.GetLabel
 */
export const LabelService_GetLabel = new RPC<GetLabelRequest,GetLabelResponse>("GET", "/v1/{name=labels/*}");
/**
 * Creates a new label.
 * Label is automatically owned by the authenticated user.
 *
 * @generated from rpc ai.h2o.workspace.v1.LabelService.CreateLabel
 */
export const LabelService_CreateLabel = new RPC<CreateLabelRequest,CreateLabelResponse>("POST", "/v1/labels", "label");
/**
 * Updates the label specified by the name.
 * Users can only update their own labels.
 *
 * @generated from rpc ai.h2o.workspace.v1.LabelService.UpdateLabel
 */
export const LabelService_UpdateLabel = new RPC<UpdateLabelRequest,UpdateLabelResponse>("PATCH", "/v1/{label.name=labels/*}", "label");
/**
 * Deletes the label specified by the name.
 * Users can only delete their own labels.
 *
 * @generated from rpc ai.h2o.workspace.v1.LabelService.DeleteLabel
 */
export const LabelService_DeleteLabel = new RPC<DeleteLabelRequest,DeleteLabelResponse>("DELETE", "/v1/{name=labels/*}");
/**
 * Lists labels owned by the authenticated user.
 *
 * @generated from rpc ai.h2o.workspace.v1.LabelService.ListLabels
 */
export const LabelService_ListLabels = new RPC<ListLabelsRequest,ListLabelsResponse>("GET", "/v1/labels");
